module.exports = __webpack_public_path__ + "static/media/media_error.c455d2fb.jpg";